
import Vue from "vue";
import AppSidebarKeyValueList, { ISidebarKeyValueRow } from "./SidebarKeyValueList.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { CountryIndex } from "@/utils/country";
import { printHumanFloat } from "@/utils/pretty-print";

export default Vue.extend({
	props: {
		item: {
			type: Object as () => any,
			required: true
		}
	},
	computed: {
		address():any {
			let address = this.item.MainAddress;
			if (!address || !address.ID) return null;
			return address;
		},
		isClient():boolean {
			return this.item.GroupID == 1;
		},
		isSupplier():boolean {
			return this.item.GroupID == 2;
		},
		rows():ISidebarKeyValueRow[] {
			let t = (key:string)=>this.$ct(`sidebar.contact-details.${key}`).toString();
			let a = this.address || {};
			let name = [a.FirstName, a.LastName].filter(v=>v).join(" ");
			let rows:ISidebarKeyValueRow[] = [
				{label: t("contact-nr"), value: this.item.ComputedFriendlyID},
				{label: t("company"), value: a.CompanyName, hideIfEmpty: true},
				{label: t("name"), value: name, hideIfEmpty: true},
				{label: t("address"), value: this.addressText},
				{label: t("country"), value: a.CountryCode ? CountryIndex.getCountryName(a.CountryCode) : ""},
				{label: t("vat"), value: this.item.Vat},
				{label: t("commercial-vat"), value: this.item.CommercialVat, hideIfEmpty: true},
				{label: t("email"), value: a.Email, href: a.Email ? `mailto:${a.Email}` : undefined},
				{label: t("phone"), value: a.Phone, href: a.Phone ? `tel:${a.Phone}` : undefined},
				{label: t("mobile"), value: a.Mobile, href: a.Mobile ? `tel:${a.Mobile}` : undefined, hideIfEmpty: true},
				{label: t("language"), value: a.Lng},
				{label: t("payment-terms"), value: this.paymentTerms},
				{label: t("discount"), value: this.item.Discount ? `${printHumanFloat(this.item.Discount, 2)} %` : "", hideIfEmpty: true},
				{label: t("discount-cash"), value: this.discountCash, hideIfEmpty: true}
			];
			if (this.isClient) {
				rows.push({label: t("price-category"), value: this.priceCategory});
			}
			if (this.isSupplier) {
				rows.push({label: t("iban"), value: this.item.Iban, hideIfEmpty: true});
				rows.push({label: t("bic"), value: this.item.Bic, hideIfEmpty: true});
			}
			return rows;
		},
		discountCash():string {
			if (!this.item.DiscountCash) return "";
			let days = this.$ct("sidebar.contact-details.days").toString();
			return `${printHumanFloat(this.item.DiscountCash, 2)} % (${this.item.DiscountCashDays} ${days})`;
		},
		postalCity():string {
			let a = this.address || {};
			return [a.Postal, a.City].filter(v=>v).join(" ");
		},
		addressText():string {
			let a = this.address || {};
			return [a.AddressLine1, a.AddressLine2, this.postalCity].filter(v=>v).join("\n");
		},
		summary():string {
			let a = this.address || {};
			return [this.postalCity, a.Phone || a.Email].filter(v=>v).join(" · ");
		},
		paymentTerms():string {
			let days = this.item.PaymentDays;
			if (days === null || days === undefined) return "";
			let key = this.item.PaymentEndMonth ? "payment-days-end-month" : "payment-days";
			return this.$ct(`sidebar.contact-details.${key}`, {days}).toString();
		},
		priceCategory():string {
			let category = this.item.SellPriceCategory;
			if (!category) return this.$ct("sidebar.contact-details.no-price-category").toString();
			return DossierConfigService.getSellCategories().getCategoryName(category);
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		item(){
			this.$emit("summary", this.summary);
		}
	},
	components: {
		AppSidebarKeyValueList
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
